import { useState } from "react";
import { MessagesSquare, FileBarChart2 } from "lucide-react";
import { CorrespondencePanel } from "../CorrespondencePanel";
import { AdminReportsPanel } from "./AdminReportsPanel";

export const CorrespondenceHub = (props) => {
  const [tab, setTab] = useState(() => sessionStorage.getItem("corr_tab_once") || "chat");
  if (sessionStorage.getItem("corr_tab_once")) sessionStorage.removeItem("corr_tab_once");
  const cls = (on) => `flex items-center gap-1.5 rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${on ? "bg-slate-900 text-white" : "bg-white text-slate-600 hover:bg-slate-100"}`;
  return (
    <div className="space-y-3">
      <div className="flex gap-2" data-testid="corr-hub-tabs">
        <button className={cls(tab === "chat")} onClick={() => setTab("chat")} data-testid="corr-hub-chat"><MessagesSquare className="h-4 w-4" /> المراسلات</button>
        <button className={cls(tab === "reports")} onClick={() => setTab("reports")} data-testid="corr-hub-reports"><FileBarChart2 className="h-4 w-4" /> التقارير الإدارية</button>
      </div>
      {tab === "chat" ? <CorrespondencePanel {...props} /> : <AdminReportsPanel />}
    </div>
  );
};
